import React from 'react';
import PropTypes from 'prop-types';

export default class FormErrors extends React.Component {
  render() {
    const errorLabels = this.props.errors.map((error) => this.errorLabel(error));
    const displayType = errorLabels.length > 0 ? "block" : "none";
    return (
      <div style={{ display: displayType }} className="alert alert-danger">
        {errorLabels}
      </div>
    );
  }

  errorLabel(error) {
    return (
      <div key={error} className="form-error">
        {error}
      </div>
    );
  }
}

FormErrors.propTypes = {
  errors: PropTypes.array
};

FormErrors.defaultProps = {
  errors: []
};
